<script setup lang="ts">
import { ref } from 'vue'
import { useCoursesStore } from '~~/stores/courses'

const emits = defineEmits(['onFinish'])
const coursesStore: Record<string, any> = useCoursesStore()
const courseDetail = computed(() => coursesStore?.state?.courseDetail)

const formState = ref([])
const submitLoading = ref<boolean>(false)

const onOkForm = () => {
  submitLoading.value = true
  coursesStore.facilitatorsRating({
    payload: {
      rateCourseFacilitators: formState.value.filter(
        (item) => !isEmpty(item.rating) || !isEmpty(item.review)
      ),
      courseSerial: courseDetail.value?.data?.serial
    },
    resolve: () => {
      submitLoading.value = false
      emits('onFinish')
    },
    reject: () => {
      submitLoading.value = false
    }
  })
}

const formChange = ({
  name,
  value,
  index,
  facilitatorSerial
}: Record<string, any>) => {
  if (isEmpty(formState.value)) {
    formState.value = [
      {
        [name]: value,
        facilitatorSerial
      }
    ]
  } else {
    formState.value[index][name] = value
    formState.value[index].facilitatorSerial = facilitatorSerial
  }
}

onMounted(() => {
  const facilitators = courseDetail.value?.data?.facilitatorDetails ?? []

  facilitators?.forEach(() => {
    formState.value.push({
      review: null,
      facilitatorSerial: null,
      rating: 0
    })
  })
})
</script>

<template>
  <a-form
    id="form-kursus-materi-rating-facilitator"
    name="facilitator-review"
    :model="formState"
    layout="vertical"
    autocomplete="off"
    class="kg-form"
    @finish="onOkForm"
  >
    <a-form-item>
      <div class="font-medium text-[18px] leading-6">
        Berikan pendapatmu tentang facilitator yang telah menemani kamu belajar
        yuk!
      </div>
    </a-form-item>
    <a-form-item>
      <div class="max-h-[500px] overflow-y-auto">
        <template
          v-for="(facilitator, index) in courseDetail?.data?.facilitatorDetails"
          :key="facilitator.serial"
        >
          <a-form-item
            :name="`rate-${index}`"
            :label="`${index + 1}. ${facilitator?.user?.fullName}`"
          >
            <a-rate
              :value="formState[index]?.rating"
              character="★"
              @change="
                formChange({
                  name: 'rating',
                  value: $event,
                  index,
                  facilitatorSerial: facilitator.serial
                })
              "
            />
          </a-form-item>
          <a-form-item name="review">
            <a-textarea
              :value="formState[index]?.review"
              :rows="4"
              placeholder="Tuliskan ulasan kamu disini"
              min
              @change="
                formChange({
                  name: 'review',
                  value: $event.target?.value,
                  index,
                  facilitatorSerial: facilitator.serial
                })
              "
            />
          </a-form-item>
        </template>
      </div>
    </a-form-item>
    <a-form-item>
      <div class="w-full text-right">
        <a-button
          type="primary"
          size="large"
          html-type="submit"
          :loading="submitLoading"
        >
          Kirim
        </a-button>
      </div>
    </a-form-item>
  </a-form>
</template>

<style lang="scss">
@use './styles.scss';
</style>
